import React from "react";

import { useModalContext } from "../../contexts/ModalContext/context";
import { Modal } from "../../components/Modal";
import { ResetInvitations } from "../../services/NetworkApi";
import { useSnackbar } from "../../hooks/useSnackbar";
import { Typography } from "../../UI/Typography";
import useAuth from "../../routes/login/AuthContext";
import { Box } from "../../UI/Box";
import { Button } from "../../UI/Button";

interface IProps {
  name: string;
  invitationId: string;
}

export const ResetInvitationsModal: React.FC<IProps> = (props) => {
  const { setIsOpen } = useModalContext();
  const { getAuthToken } = useAuth();
  const { showErrorSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = React.useState(false);

  const handleClose = () => setIsOpen(false);

  const handleReset = async () => {
    setIsLoading(true);

    const res = await ResetInvitations(props.invitationId, await getAuthToken());

    if (!res.ok) {
      showErrorSnackbar("An error occurred. Please try again later!");
    }

    handleClose();
    setIsLoading(false);
  };

  return (
    <Modal
      maxWidth="sm"
      title="Reset Invitation Email"
      actions={
        <>
          <Button onClick={handleClose}>Cancel</Button>
          <Button appearance="primary" isDisabled={isLoading} onClick={handleReset}>
            Reset
          </Button>
        </>
      }
    >
      <Box px={3} py={2}>
        <Typography gutterBottom>
          By clicking send below, {props.name} will receive their invitation email again which includes their one-time
          use access link. This invitation will be sent to the email address in their user profile.
        </Typography>
        <Typography gutterBottom>
          To send to a different email address, update this in your management system and wait for the change to take
          effect in the RoomSync administrative site.
        </Typography>
      </Box>
    </Modal>
  );
};
